import axios from "axios";
import { Config } from "../config/config";
import { processLoadOptions } from "../helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/language`

export const languageService = {
    getLanguages: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-languages`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    }
};